import { APIGet, APIPost, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

const apiVersion = "2024-04";
const adminType = "master-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/customer";

export async function GetCustomer(params: any, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<any[]>(baseUrl, params, useGlobalLoader, token);
}

export async function PostCustomer(params: any, useGlobalLoader: boolean) {
  return await APIPost(baseUrl, params, useGlobalLoader);
}

interface IGetCustomerPaymentMethodParams {
  id?: number;
  customer_id?: number;
  client_id: number;
}

export async function GetCustomerPaymentMethod(params: IGetCustomerPaymentMethodParams, useGlobalLoader?: boolean) {
  return await APIGet(baseUrl + "/payment-method", params, useGlobalLoader);
}

export async function PostStandaloneCustomerImport(params: FormData, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.MasterAdmin, '/customer/import-standalone'), params, useGlobalLoader);
}
